import { connectToParent } from 'penpal';
import Service from '@ember/service';

export default class PenpalService extends Service {
  // workaround to allow stubbing in tests
  connectToParent = connectToParent;
}
